import { render, staticRenderFns } from "./add-producer-brand.vue?vue&type=template&id=346d276a&"
import script from "./add-producer-brand.vue?vue&type=script&lang=js&"
export * from "./add-producer-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports